import { createContext, useContext } from 'react';
import type { GridRect } from '../../model/workspace-document';

/** Estado visual del arrastre de una tarjeta (overlay + hueco de encaje). */
export interface CardDragSession {
  readonly cardId: string;
  readonly title: string;
  readonly widthPx: number;
  readonly heightPx: number;
  readonly snap: GridRect | null;
}

export const CardDragSessionContext = createContext<CardDragSession | null>(null);

export const useCardDragSession = (): CardDragSession | null => useContext(CardDragSessionContext);
